module.exports = __webpack_public_path__ + "img/qrcode_register2.377fb1d4.png";